(function () {

/**
 * A single particle in the particle animation.
 * Particles are initialized with random positions and velocities.
 * They move towards a destination point and bounce of a radius around the cursor.
 */ class $5c66f60628562450$var$Particle {
    /**
   * Creates a new Particle.
   * @param {number} x - Destination x-coordinate.
   * @param {number} y - Destination y-coordinate.
   * @param {number} ww - Canvas width.
   * @param {number} wh - Canvas height.
   * @param {CanvasRenderingContext2D} ctx - Canvas rendering context.
   * @param {string} purpose - Purpose of the particle ("text" or other).
   * @param {object} constraints - Constraints for particle size.
   * @param {string} [color] - Optional color of the particle.
   */ constructor(x, y, ww, wh, ctx, purpose, constraints, color){
        this.ctx = ctx;
        // Initialize particle position with a slight random offset
        this.x = Math.sin(Math.random()) * ww / 10 + x;
        this.y = Math.sin(Math.random()) * wh / 10 + y;
        // Set destination position
        this.dest = {
            x: x,
            y: y
        };
        this.XPosIsLeftOfDest = this.x <= this.dest.x;
        this.YPosIsUpOfDst = this.y <= this.dest.y;
        // If the particle is part of a text, increase its radius
        this.r = purpose === "text" ? 1.3 * constraints.particleSize() : constraints.particleSize();
        // Increase radius on small screens
        if (window.innerWidth < 550) this.r *= 1.5;
        // Initialize velocity with random values (-2.5 to 2.5)
        this.vx = (Math.random() - 0.5) * 5;
        this.vy = (Math.random() - 0.5) * 5;
        // Initialize acceleration
        this.accX = 0;
        this.accY = 0;
        // Random friction coefficient between 0.94 and 0.99 to simulate drag
        this.friction = Math.random() * 0.05 + 0.94;
        // Store the original friction value
        this.oFriction = this.friction;
        // Random throttle value between 0.97 and 0.995 to adjust friction over time
        this.throttle = Math.random() * 0.025 + 0.97;
        // Set particle color; use provided color or pick random from COLORS
        this.color = color || (0, $f0955d2d14661d12$export$56d196d2844d1ca1)[Math.floor(Math.random() * 5)];
        // Store the purpose (e.g., "text")
        this.purpose = purpose;
    }
    /**
   * Removes the particle by setting its destination off-screen.
   */ remove() {
        // Move the particle off-screen by setting destination coordinates
        this.dest.x = -9999;
        this.dest.y = -9999;
    }
    /**
   * Updates particle position, applies interactions, and renders it.
   * @param {object} mouse - Object containing mouse x and y coordinates.
   */ render(mouse) {
        // Calculate acceleration towards destination
        this.accX = (this.dest.x - this.x) / 1000;
        this.accY = (this.dest.y - this.y) / 1000;
        // Check if particle has crossed its destination in x-direction
        if (this.dest.x - this.x >= 0 !== this.XPosIsLeftOfDest) {
            // Adjust friction using throttle
            this.friction *= this.throttle;
            // Toggle direction flag
            this.XPosIsLeftOfDest = !this.XPosIsLeftOfDest;
        }
        // Check if particle has crossed its destination in y-direction
        if (this.dest.y - this.y >= 0 !== this.YPosIsUpOfDst) {
            // Adjust friction using throttle
            this.friction *= this.throttle;
            // Toggle direction flag
            this.YPosIsUpOfDst = !this.YPosIsUpOfDst;
        }
        // Update velocity with acceleration
        this.vx += this.accX;
        this.vy += this.accY;
        // Apply friction to velocity
        this.vx *= this.friction;
        this.vy *= this.friction;
        // Update position with velocity
        this.x += this.vx;
        this.y += this.vy;
        // Draw the particle on the canvas
        this.ctx.fillStyle = this.color;
        this.ctx.beginPath();
        this.ctx.arc(this.x, this.y, this.r, Math.PI * 2, false);
        this.ctx.fill();
        // Calculate distance between particle and mouse cursor
        const dx = Math.abs(this.x - mouse.x);
        const dy = Math.abs(this.y - mouse.y);
        const distance = Math.sqrt(dx * dx + dy * dy);
        // If mouse is within 120 pixels of particle
        if (distance < 120) {
            // Apply repulsion effect away from mouse
            this.accX = (this.x - mouse.x) / 100;
            this.accY = (this.y - mouse.y) / 100;
            this.vx += this.accX;
            this.vy += this.accY;
            // Reset friction to original value
            this.friction = this.oFriction;
            // Adjust throttle slightly
            this.throttle = Math.random() * 0.025 + 0.965;
        }
    }
}
var $5c66f60628562450$export$2e2bcd8739ae039 = $5c66f60628562450$var$Particle;


const $f0955d2d14661d12$export$c36c68baa13912a5 = (0, $5c66f60628562450$export$2e2bcd8739ae039);
const $f0955d2d14661d12$var$aVW = (val, cw)=>val * (cw / 100);
const $f0955d2d14661d12$var$aVH = (val, ch)=>val * (ch / 100);
const $f0955d2d14661d12$export$3d681ef8aa29ccb0 = (cw, ch)=>({
        desktop: {
            nameFont: `bold ${$f0955d2d14661d12$var$aVW(15, cw)}px sans-serif`,
            nameCoords: [
                cw / 2.5,
                ch / 2
            ],
            nameStep: Math.round(cw / 125),
            particleSize: ()=>Math.random() * $f0955d2d14661d12$var$aVW(0.15, cw) + $f0955d2d14661d12$var$aVW(0.2, cw)
        },
        mobile: {
            nameFont: `bold ${$f0955d2d14661d12$var$aVW(25, cw)}px sans-serif`,
            nameCoords: [
                [
                    cw / 2,
                    $f0955d2d14661d12$var$aVH(40, ch)
                ],
                [
                    cw / 2,
                    $f0955d2d14661d12$var$aVH(55, ch)
                ]
            ],
            nameStep: Math.round(cw / 55),
            particleSize: ()=>Math.random() * $f0955d2d14661d12$var$aVW(0.15, cw) + $f0955d2d14661d12$var$aVW(0.25, cw)
        }
    });
const $f0955d2d14661d12$export$56d196d2844d1ca1 = [
    "#ee4035",
    "#f37736",
    "#fdf498",
    "#7bc043",
    "#0392cf"
];
var $f0955d2d14661d12$export$2e2bcd8739ae039 = {
    Particle: $f0955d2d14661d12$export$c36c68baa13912a5,
    COLORS: $f0955d2d14661d12$export$56d196d2844d1ca1,
    constraints: $f0955d2d14661d12$export$3d681ef8aa29ccb0
};


// Create a new Date object
const $b52fc5f529c4f8c1$export$6f1a8a9dea66d665 = ()=>{
    const now = new Date();
    // Extract hours, minutes, and seconds
    let hours = now.getHours();
    let minutes = now.getMinutes();
    let seconds = now.getSeconds();
    // Ensure two-digit format by padding with leading zeros if necessary
    hours = hours.toString().padStart(2, "0");
    minutes = minutes.toString().padStart(2, "0");
    seconds = seconds.toString().padStart(2, "0");
    // Combine into hh:mm:ss format
    const timeString = `${hours}:${minutes}:${seconds}`;
    return timeString;
};



let $f9842f2de5eb5719$var$mouse = {
    x: 0,
    y: 0
};
let $f9842f2de5eb5719$var$particles = [];
let $f9842f2de5eb5719$var$shapes = [];
let $f9842f2de5eb5719$var$ctx;
let $f9842f2de5eb5719$var$cw, $f9842f2de5eb5719$var$ch;
let $f9842f2de5eb5719$var$shapeCnt = 0;
let $f9842f2de5eb5719$var$constraints;
let $f9842f2de5eb5719$var$mobile = false;
const $f9842f2de5eb5719$var$canvas = document.querySelector("canvas");
$f9842f2de5eb5719$var$canvas.width = window.innerWidth;
$f9842f2de5eb5719$var$canvas.height = window.innerHeight;
const $f9842f2de5eb5719$var$particleRender = ()=>{
    requestAnimationFrame($f9842f2de5eb5719$var$particleRender);
    $f9842f2de5eb5719$var$ctx.clearRect(0, 0, $f9842f2de5eb5719$var$cw, $f9842f2de5eb5719$var$ch);
    let allshapesgone = true;
    for (const p of $f9842f2de5eb5719$var$particles)p.render($f9842f2de5eb5719$var$mouse);
    for (const p of $f9842f2de5eb5719$var$shapes){
        p.render($f9842f2de5eb5719$var$mouse);
        if (p.x >= 0 || p.y >= 0) allshapesgone = false;
    }
    if (allshapesgone) $f9842f2de5eb5719$var$shapes = [];
};
const $f9842f2de5eb5719$var$initCanvas = ()=>{
    $f9842f2de5eb5719$var$ctx = $f9842f2de5eb5719$var$canvas.getContext("2d");
    $f9842f2de5eb5719$var$cw = $f9842f2de5eb5719$var$canvas.width;
    $f9842f2de5eb5719$var$ch = $f9842f2de5eb5719$var$canvas.height;
    $f9842f2de5eb5719$var$mobile = window.innerWidth < 550;
    $f9842f2de5eb5719$var$constraints = $f9842f2de5eb5719$var$mobile ? (0, $f0955d2d14661d12$export$3d681ef8aa29ccb0)($f9842f2de5eb5719$var$cw, $f9842f2de5eb5719$var$ch).mobile : (0, $f0955d2d14661d12$export$3d681ef8aa29ccb0)($f9842f2de5eb5719$var$cw, $f9842f2de5eb5719$var$ch).desktop;
    $f9842f2de5eb5719$var$setParticlesToCurrentTime();
};
const $f9842f2de5eb5719$var$setParticlesToCurrentTime = ()=>{
    $f9842f2de5eb5719$var$ctx.clearRect(0, 0, $f9842f2de5eb5719$var$cw, $f9842f2de5eb5719$var$ch);
    $f9842f2de5eb5719$var$ctx.font = $f9842f2de5eb5719$var$constraints.nameFont;
    $f9842f2de5eb5719$var$ctx.textAlign = "center";
    if ($f9842f2de5eb5719$var$mobile) $f9842f2de5eb5719$var$ctx.fillText("hello!", ...$f9842f2de5eb5719$var$constraints.nameCoords[0]);
    else $f9842f2de5eb5719$var$ctx.fillText(`${(0, $b52fc5f529c4f8c1$export$6f1a8a9dea66d665)()}`, ...$f9842f2de5eb5719$var$constraints.nameCoords);
    const data = $f9842f2de5eb5719$var$ctx.getImageData(0, 0, $f9842f2de5eb5719$var$cw, $f9842f2de5eb5719$var$ch).data;
    $f9842f2de5eb5719$var$ctx.clearRect(0, 0, $f9842f2de5eb5719$var$cw, $f9842f2de5eb5719$var$ch);
    const newParticles = [];
    for(let i = 0; i < $f9842f2de5eb5719$var$cw; i += $f9842f2de5eb5719$var$constraints.nameStep){
        for(let j = 0; j < $f9842f2de5eb5719$var$ch; j += $f9842f2de5eb5719$var$constraints.nameStep)// check if pixel is not transparent
        if (data[(i + j * $f9842f2de5eb5719$var$cw) * 4 + 3] > 100) {
            let p = $f9842f2de5eb5719$var$particles.find((p)=>p.dest.x === i && p.dest.y === j);
            newParticles.push(p || new (0, $f0955d2d14661d12$export$c36c68baa13912a5)(i, j, $f9842f2de5eb5719$var$cw, $f9842f2de5eb5719$var$ch, $f9842f2de5eb5719$var$ctx, "text", $f9842f2de5eb5719$var$constraints));
        }
    }
    $f9842f2de5eb5719$var$particles = newParticles;
};
// particle shapes
window.addEventListener("click", (e)=>{
    const [x, y] = [
        e.clientX,
        e.clientY
    ];
    let step = Math.round($f9842f2de5eb5719$var$ch / 150);
    if ($f9842f2de5eb5719$var$mobile) step = Math.round($f9842f2de5eb5719$var$ch / 100);
    const shapeID = Math.floor(Math.random() * 4);
    const color = (0, $f0955d2d14661d12$export$56d196d2844d1ca1)[Math.floor(Math.random() * 5)];
    // shape counter
    $f9842f2de5eb5719$var$shapeCnt++;
    if ($f9842f2de5eb5719$var$shapeCnt === 8) {
        $f9842f2de5eb5719$var$shapes.forEach((p)=>p.remove());
        $f9842f2de5eb5719$var$shapeCnt = 0;
    }
    // eslint-disable-next-line default-case
    switch(shapeID){
        case 0:
            {
                // triangle flood-filling
                const v1 = {
                    x: // top
                    x,
                    y: y - Math.random() * 55 + 70
                };
                let dx = Math.random() * 155 + 100;
                let dy = Math.random() * 75 + 80;
                const v2 = {
                    // left
                    x: x - dx,
                    y: y + dy
                };
                const v3 = {
                    // right
                    x: x + dx,
                    y: y + dy
                };
                const invslopeLeft = (v2.x - v1.x) / (v2.y - v1.y);
                const invslopeRight = (v3.x - v1.x) / (v3.y - v1.y);
                let boundLeft = v1.x;
                let boundRight = v1.x;
                for(let y = v1.y; y <= v2.y; y += step * 1.25){
                    for(let x = boundLeft; x <= boundRight; x += step * 1.25)$f9842f2de5eb5719$var$shapes.push(new (0, $f0955d2d14661d12$export$c36c68baa13912a5)(x, y, $f9842f2de5eb5719$var$cw, $f9842f2de5eb5719$var$ch, $f9842f2de5eb5719$var$ctx, "triangle", $f9842f2de5eb5719$var$constraints, color));
                    boundLeft += invslopeLeft;
                    boundRight += invslopeRight;
                }
                break;
            }
        case 2:
            {
                // rectangle
                const rect = Math.random() > 0.5;
                let width, height;
                if (rect) {
                    width = Math.random() * 25 + 40;
                    height = Math.random() * 25 + 40;
                } else width = height = Math.random() * 25 + 40;
                for(let i = x - width / 2; i <= x + width / 2; i += step * 1.25)for(let j = y - height / 2; j <= y + height / 2; j += step * 1.25)$f9842f2de5eb5719$var$shapes.push(new (0, $f0955d2d14661d12$export$c36c68baa13912a5)(i, j, $f9842f2de5eb5719$var$cw, $f9842f2de5eb5719$var$ch, $f9842f2de5eb5719$var$ctx, "rect", $f9842f2de5eb5719$var$constraints, color));
                break;
            }
        case 3:
            {
                // circle
                const r = Math.random() * 25 + 55;
                for(let i = x - r; i <= x + r; i += step)for(let j = y - r; j <= y + r; j += step){
                    const dx = Math.abs(i - x), dy = Math.abs(j - y);
                    // check if in circle radius
                    if (Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2)) <= r) {
                        const p = new (0, $f0955d2d14661d12$export$c36c68baa13912a5)(i, j, $f9842f2de5eb5719$var$cw, $f9842f2de5eb5719$var$ch, $f9842f2de5eb5719$var$ctx, "circle", $f9842f2de5eb5719$var$constraints, color);
                        $f9842f2de5eb5719$var$shapes.push(p);
                    }
                }
                break;
            }
    }
});
// name particles
window.addEventListener("resize", $f9842f2de5eb5719$var$initCanvas);
window.addEventListener("mousemove", (e)=>{
    $f9842f2de5eb5719$var$mouse.x = e.clientX;
    $f9842f2de5eb5719$var$mouse.y = e.clientY;
});
$f9842f2de5eb5719$var$initCanvas();
requestAnimationFrame($f9842f2de5eb5719$var$particleRender);
setInterval(()=>{
    $f9842f2de5eb5719$var$setParticlesToCurrentTime();
}, 2000);

})();
//# sourceMappingURL=index.a18129bb.js.map
